/* eslint-disable no-tabs */
import { Box, Flex } from '@chakra-ui/react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ElementoTooltipCmp } from '../../../../../components/ElementoTooltipCmp'
import { iFeedbackPersonalizadoQuery } from '../../../../../interfaces'
import { appApi } from '../../../../../services/appApi'

interface iProps {
  tipo: 'Quantitativa'|'Indicativa'
  isDisabled?: boolean
  queryParams: iFeedbackPersonalizadoQuery
}

export const BoxModelo: React.FC<iProps> = ({ tipo, children, isDisabled, queryParams }) => {
  const nav = useNavigate()
  const { pathname } = useLocation()

  function onNav(path: string): void {
    if (queryParams.feedbackId) {
      appApi.patch(`FeedbackPersonalizado/${queryParams.feedbackId ?? ''}/Item/${queryParams.itemFeedbackId ?? ''}?fase=${queryParams.fase}&tipo=${tipo === 'Quantitativa' ? 3 : 4}`)
        .then(() => nav(`${path}?feedbackId=${queryParams.feedbackId}&itemFeedbackId=${queryParams.itemFeedbackId}&fase=${queryParams.fase}`))
        .catch((err) => console.log(err))
    } else {
      nav(path)
    }
  }

  return (
    <ElementoTooltipCmp label={''}>
      <Flex
        className={''}
        borderRadius={'.325rem'}
        bg={tipo === 'Quantitativa' ? 'var(--v2Opaco)' : 'var(--AzulOpaco)'}
        cursor='pointer'
      >
        <Box
          onClick={() => onNav(`${pathname.replace('SelecionarModelo', tipo)}/Criar`)}
          px={'1rem'}
          py={'.875rem'}
          bgColor={tipo === 'Quantitativa' ? 'var(--Green1)' : 'var(--Azul)'}
          color={'#fff'}
          borderRadius={'.325rem'}
          _hover={{
            transform: 'translate(0rem,-0.25rem)',
            transition: 'all 0.2s ease'
          }}
        >
          {children}
        </Box>
      </Flex>
    </ElementoTooltipCmp>
  )
}
